<template>
  <div class="wa-preview">
    <div class="wa-preview__label">Vista previa</div>
    <div class="wa-preview__phone">
      <div class="wa-preview__bubble">
        <div v-if="hasHeader" class="wa-preview__header">
          {{ header }}
        </div>
        <div class="wa-preview__body" v-html="formattedBody"></div>
        <div v-if="footer" class="wa-preview__footer">{{ footer }}</div>
        <div class="wa-preview__time">{{ time }}</div>
      </div>
      <div v-if="buttons && buttons.length" class="wa-preview__buttons">
        <div v-for="(btn, i) in buttons" :key="i" class="wa-preview__btn">
          {{ btn.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhatsappTemplatePreview",
  props: {
    header: { type: String, default: "" },
    body: { type: String, default: "" },
    footer: { type: String, default: "" },
    buttons: { type: Array, default: () => [] },
    sampleVariables: { type: Array, default: () => [] }
  },
  computed: {
    hasHeader() {
      return this.header && this.header.trim().length > 0;
    },
    resolvedBody() {
      if (!this.body) return "";
      let text = this.body;
      const samples = this.sampleVariables.length
        ? this.sampleVariables
        : ["nombre", "valor", "fecha", "link"];
      samples.forEach((val, i) => {
        text = text.replace(
          new RegExp(`\\{\\{${i + 1}\\}\\}`, "g"),
          `<strong>${val}</strong>`
        );
      });
      return text;
    },
    formattedBody() {
      return this.resolvedBody
        .replace(/\n/g, "<br>")
        .replace(/\*(.*?)\*/g, "<strong>$1</strong>")
        .replace(/_(.*?)_/g, "<em>$1</em>");
    },
    time() {
      const now = new Date();
      return (
        now
          .getHours()
          .toString()
          .padStart(2, "0") +
        ":" +
        now
          .getMinutes()
          .toString()
          .padStart(2, "0")
      );
    }
  }
};
</script>

<style scoped>
.wa-preview {
  background: #f0f0f0;
  border-radius: 10px;
  padding: 16px;
  min-width: 240px;
}
.wa-preview__label {
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
  font-weight: 600;
}
.wa-preview__phone {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.wa-preview__bubble {
  background: #d9fdd3;
  border-radius: 8px 0 8px 8px;
  padding: 10px 12px 6px;
  max-width: 280px;
  word-break: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  align-self: flex-end;
  position: relative;
}
.wa-preview__header {
  font-weight: 700;
  font-size: 13px;
  margin-bottom: 6px;
  color: #111;
}
.wa-preview__body {
  font-size: 13px;
  line-height: 1.5;
  color: #111;
  white-space: pre-wrap;
}
.wa-preview__footer {
  font-size: 11px;
  color: #6b7280;
  margin-top: 6px;
}
.wa-preview__time {
  font-size: 10px;
  color: #6b7280;
  text-align: right;
  margin-top: 4px;
}
.wa-preview__buttons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-self: flex-end;
  max-width: 280px;
  width: 100%;
}
.wa-preview__btn {
  background: #fff;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  color: #00a5f4;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  cursor: default;
}
</style>
